<page-data-manager>
  <div class="flash-message-container">
    <flash-message></flash-message>
  </div>

  <div class="row">
    <div class="col-xs-12">
      <div class='page-header'>
        <div class='btn-toolbar pull-right'>
          <div class='btn-group'>
            <a class="btn btn-primary btn-sm btn-action" href="#!/gleba/new" uib-tooltip="Novo Talhão" tooltip-placement="left" ng-if="permissions.glebas.canManage">
              Novo <i class="fa fa-plus"></i>
            </a>
          </div>
        </div>
        <h2>Talhões</h2>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-xs-12" ng-show="glebas">
      <div class="panel panel-default">
        <div class="panel-body">
          <div class="row">
            <div class="col-xs-12 col-md-6">
              <label>Propriedade</label>
              <ui-select ng-model="cadastroGleba.propriedade" theme="bootstrap">
                <ui-select-match placeholder="">{{$select.selected.descricao | capitalize}}</ui-select-match>
                <ui-select-choices repeat="propriedade in propriedadesGlebas | filter: $select.search">
                  <span class="form-group" ng-bind-html="propriedade.descricao | capitalize | highlight: $select.search"></span>
                </ui-select-choices>
              </ui-select>
            </div>
            <div class="col-xs-12">
              <label>Filtrar</label>
            </div>
            <div class="col-xs-3 form-group">
              <select class="form-control" ng-model="cadastroGleba.status">
                <option value="all">Todos</option>
                <option value="active">Apenas ativos</option>
                <option value="inactive">Apenas inativos</option>
              </select>
            </div>
            <div class="col-xs-2">
              <div class="btn-group">
                <button type="submit" class="btn btn-success" ng-click="list(cadastroGleba.propriedade)">
                  <i class="fa fa-search"></i>
                </button>
              </div>
            </div>
          </div>

          <hr>

          <div class="row">
            <div class="col-xs-12">
              <small ng-show="glebas.length == 0">Nenhum talhão encontrado!</small>

              <table class="table table-hover table-striped" ng-show="glebas.length > 0">
                <thead>
                  <tr>
                    <th class="col-xs-7">Descrição</th>
                    <th class="col-xs-2 text-center">Tem Coordenadas?</th>
                    <th class="col-xs-2 text-right">Área (ha)</th>
                    <th class="col-xs-1"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr ng-repeat="gleba in glebas track by $index">
                    <td class="vertical-middle">{{gleba.descricao | capitalize}}</td>
                    <td class="vertical-middle text-center">{{gleba.tem_kml ? 'Sim' : 'Não'}}</td>
                    <td class="vertical-middle text-right">{{gleba.area_total | number:2}}</td>
                    <td class="vertical-middle text-right">
                      <div class="btn btn-primary btn-sm" ng-click="show($index)" uib-tooltip="Visualizar" tooltip-placement="top">
                        <i class="glyphicon glyphicon-eye-open"></i>
                      </div>
                      
                      <div class="btn btn-primary btn-sm" ng-click="inactivate(gleba.id)" uib-tooltip="Inativar Talhão" tooltip-placement="top"
                        ng-if="permissions.glebas.canManage && !gleba.data_baixa">
                        <i class="glyphicon glyphicon-trash"></i>
                      </div>

                      <div class="btn btn-primary btn-sm" ng-click="activate(gleba.id)" uib-tooltip="Ativar Talhão" tooltip-placement="top" 
                        ng-if="permissions.glebas.canManage && !!gleba.data_baixa">
                        <i class="glyphicon glyphicon-cog"></i>
                      </div>
                      
                      <a ng-disabled="!gleba.tem_kml" ng-href="{{gleba.linkKml}}" class="btn btn-primary btn-sm" uib-tooltip="Download KML" tooltip-placement="top">
                        <i class="glyphicon glyphicon-download-alt"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</page-data-manager>
